import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { useRelatoriosV2 } from '../utils/relatorios-page-loader';
import { FeatureFlagsService } from '../services/feature-flags.service';

/**
 * Redireciona rotas legadas de templates para o hub quando relatórios v2 e layout moderno estão ativos.
 */
export const relatoriosV2TemplatesRedirectGuard: CanActivateFn = async () => {
  const flags = inject(FeatureFlagsService);
  const router = inject(Router);

  if (await useRelatoriosV2(flags)) {
    return router.createUrlTree(['/eventos/relatorios']);
  }
  return true;
};
